module.exports = __webpack_public_path__ + "img/ican-logo.7326fe00.png";